import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MultiSelectDropdownItem } from '@lytx/platform.ui.components';

@Component({
  selector: 'dcc-query-builder',
  templateUrl: './query-builder.component.html',
  styleUrls: ['./query-builder.component.scss'],
})
export class QueryBuilderComponent implements OnInit {
  @Input() options!: QueryOptions;
  @Input() query: RawShadowQuery = {};
  @Input() total: number;
  @Input() isLoading = false;
  @Output() search = new EventEmitter<RawShadowQuery>();

  platforms: MultiSelectDropdownItem[] = [
    { label: 'SF500', item: 'SF500' },
    { label: 'SF400', item: 'SF400' },
    { label: 'SF400V2', item: 'SF400V2' },
    { label: 'SF400V2W', item: 'SF400V2W' },
    { label: 'SF300', item: 'SF300' },
    { label: 'SF300V2', item: 'SF300V2' },
    { label: 'SF300W', item: 'SF300W' },
    { label: 'SF200', item: 'SF200' },
    { label: 'SF64', item: 'SF64' },
    { label: 'SF1', item: 'SF1' },
  ];

  initialPlatforms: MultiSelectDropdownItem[] = [];

  ngOnInit(): void {
    if (this.query.platforms) {
      this.initialPlatforms = this.query.platforms.map((platform) => ({
        label: platform,
        item: platform,
        isSelected: true,
      }));
    }
  }

  selectPlatforms(platforms: string[]) {
    this.query.platforms = platforms;
  }

  reset() {
    this.query = {};
    this.platforms.forEach((platform) => (platform.isSelected = false));
    this.onSearchClick();
  }

  onSearchClick() {
    this.search.emit(this.query);
  }

  addFilter(valueType: ValueType, filterType?: FilterType) {
    if (!this.query.filters) {
      this.query.filters = [];
    }

    this.query.filters.push({
      propertyName: '',
      value: '',
      valueType,
      filterType,
    });
  }

  addDateRangeStartFilter() {
    this.addFilter(ValueType.Date, FilterType.RangeStart);
  }

  addDateRangeEndFilter() {
    this.addFilter(ValueType.Date, FilterType.RangeEnd);
  }

  addExactValueFilter() {
    this.addFilter(ValueType.Text, FilterType.Equals);
  }

  addValueRangeStartFilter() {
    this.addFilter(ValueType.Text, FilterType.RangeStart);
  }

  addValueRangeEndFilter() {
    this.addFilter(ValueType.Text, FilterType.RangeEnd);
  }

  addExistsFilter() {
    this.addFilter(ValueType.Exists);
  }

  addDoesNotExistFilter() {
    this.addFilter(ValueType.DoesNotExist);
  }

  deleteFilter(filter: Filter) {
    this.query.filters = this.query.filters.filter((f) => f !== filter);
  }

  getDaysAgoValue(days: number) {
    return new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
  }
}

export interface QueryOptions {
  name: string;
  description?: string;
  baseFilters?: Filter[];
  showAdvanced?: boolean;
}

export interface Filter {
  propertyName: string;
  value: string;
  valueType: ValueType;
  filterType?: FilterType;
}

export enum FilterType {
  RangeStart = 'start',
  RangeEnd = 'end',
  Equals = 'equals',
}

export enum ValueType {
  Date,
  Text,
  Exists,
  DoesNotExist,
}

export interface RawShadowQuery {
  filters?: Filter[];
  can1Type?: string;
  companyId?: number;
  platforms?: string[];
}
